import { api, applyAuthHeaders } from './http'
import { setStoredAuth, clearStoredAuth } from '../auth/storage'

// Flujo de autenticación Qualita — VERIFICADO EN VIVO contra el backend MT (2026-06-25)
// y contra el código fuente real (qualita-core-frontend AuthenticationService /
// AuthorizationService / HttpInterceptor, y app/scripts/controllers/login.js):
//
//  1. POST /login {username,password}
//        -> { accessToken, requestToken, username }   (token OPACO tipo ApiKey, no JWT)
//        -> header Authorization: Bearer <accessToken>
//  2. GET  /authorization/principal
//        -> { permisos:[...], roles, stamp, username }  (clave "permisos" en español)
//  3. POST /loginApp  con body { username }  (¡SOLO username, NO password!)
//        -> el objeto "accesoSistema" del usuario:
//           { id, nombres, ..., cajas:[...], accesos:[ { id, accesoPorDefecto, locacion:{...} } ] }
//        La LOCACIÓN sale de accesos[] (no de /login). El default es el que tiene
//        accesoPorDefecto==true; su locacion.id va en el header X-Access.
//        AuthenticationService.token usa data.accesosSistema[0].locacion.id (alias del
//        mismo array en el interceptor); login.js usa accesos[0].locacion.id. En el MT
//        confirmado el array es "accesos" (len=1, accesoPorDefecto=true, locacion.id=1).
//  4. refresh: POST /token { username, accessToken, requestToken } -> { accessToken, requestToken }.
//        OJO: el refresh INVALIDA el accessToken anterior (confirmado en vivo).
//
// La CAJA del usuario (necesaria para el proceso de cobro / cobro ágil) sale de
// accesoSistema.cajas[], filtrada por caja.puntoEmision.puntoVenta.sucursal.id ==
// locacion.sucursal.id (ver form.js:8650-8653). Se persiste en auth.cajas / auth.caja.
export async function login(username, password) {
  // 1) auth core
  const { data: loginRes } = await api.post('/login', { username, password })
  const accessToken = loginRes.accessToken || loginRes.token
  const requestToken = loginRes.requestToken || loginRes.refreshToken || null
  let auth = { username: loginRes.username || username, accessToken, requestToken }
  applyAuthHeaders(auth)

  // 2) permisos (antes del loginApp, igual que setupCredentials en el core)
  try {
    const { data: principal } = await api.get('/authorization/principal')
    auth.permissions = principal.permisos || principal.permissions || []
    auth.roles = principal.roles || []
    auth.stamp = principal.stamp
  } catch (e) {
    console.warn('No se pudieron cargar permisos (/authorization/principal)', e)
    auth.permissions = []
  }

  // 3) loginApp -> accesoSistema (tenant ya resuelto por username en el backend).
  //    Body: SOLO { username }. La respuesta ES el accesoSistema (objeto, no { accesos }).
  let accesoSistema = null
  try {
    const { data } = await api.post('/loginApp', { username: auth.username })
    accesoSistema = data || null
  } catch (e) {
    console.warn('loginApp falló; sin locación/caja resueltas (revisar en vivo)', e)
  }

  const accesos = accesoSistema?.accesos || accesoSistema?.accesosSistema || []
  const accesoDefault = accesos.find((a) => a.accesoPorDefecto === true) || accesos[0] || null
  const locacion = accesoDefault?.locacion || null

  auth.accesoSistema = accesoSistema
  auth.accesos = accesos
  auth.locacion = locacion
  auth.locacionId = locacion?.id ?? null

  // CAJA del usuario para el flujo de cobro: la que matchea la sucursal de la locación.
  const cajas = accesoSistema?.cajas || []
  const sucursalId = locacion?.sucursal?.id
  auth.cajas = cajas
  auth.caja =
    cajas.find((c) => c?.puntoEmision?.puntoVenta?.sucursal?.id === sucursalId) || cajas[0] || null

  applyAuthHeaders(auth) // re-aplica con X-Access = locacionId

  setStoredAuth(auth)
  return auth
}

export async function logout() {
  try {
    // El core hace $save({action:'logout'}) con { username, accessToken } -> POST /logout
    await api.post('/logout')
  } catch {
    /* ignore */
  }
  clearStoredAuth()
  applyAuthHeaders(null)
}
